/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/** Strip leading `+` from a dialing code (e.g. "+60" → "60"). */
export function normalizeDialingCode(value?: string): string {
  if (!value) return '';
  return value.startsWith('+') ? value.replace('+', '') : value;
}

/** Ensure dialing code is displayed with a leading `+`. */
export function withPlusDialingCode(value?: string): string {
  if (!value) return '';
  return value.startsWith('+') ? value : `+${value}`;
}

/** Concatenate dialing code (no +) + national number for API payloads. */
export function formatMobilePhone(
  dialingCode: string | undefined,
  phoneNumber: string | undefined,
): string {
  if (!phoneNumber) return '';
  return `${normalizeDialingCode(dialingCode)}${phoneNumber.trim()}`;
}

/** True when dialing code + phone match the user's current number. */
export function isSamePhoneNumber(
  currentDialingCode: string | undefined,
  currentPhoneNumber: string | undefined,
  dialingCode: string | undefined,
  phoneNumber: string | undefined,
): boolean {
  if (
    !currentPhoneNumber ||
    !currentDialingCode ||
    !dialingCode ||
    !phoneNumber
  ) {
    return false;
  }
  return (
    phoneNumber === currentPhoneNumber &&
    normalizeDialingCode(dialingCode) ===
      normalizeDialingCode(currentDialingCode)
  );
}
